import Theme from '@/classes/theme';

export default {
  theme: state => new Theme(state)
};
